<template>
  <ListItem class="card card--narrow">
    <template v-slot:row-cols>
      <div class="card__header">
        <span class="card__title">{{ title }}</span>
        <span class="card__header--description">{{ description }}</span>
        <span class="card__header--date">{{ date }}</span>
      </div>
    </template>
    <template v-slot:toggle-area>
      <slot name="section"></slot>
    </template>
  </ListItem>
</template>

<script>
import ListItem from '@/components/ListItems/index.vue'

export default {
  name: 'SectionTab',
  props: {
    title: { type: String, required: true },
    description: { type: String, default: '' },
    date: { type: String, default: '' },
  },
  components: { ListItem },
}
</script>

<style lang="scss" scoped>
@import '@/views/reporting/reporting-industry.scss';
</style>
